module.exports = __webpack_public_path__ + "media/images/icons/star_outline-b82b1aba6ea962c914986877a106baca.svg";